export default __webpack_public_path__ + "static/media/synapse.20d7bc07.svg";